<template>
  <div class="chapterInfo">
    <div class="header">
      <el-button type="primary" @click="handleChapterAdd">新增章</el-button>
    </div>
    <el-table
      ref="sectionTable"
      v-loading="loading"
      :data="sectionList"
      style="width: 100%;margin-bottom: 20px;"
      row-key="rowKey"
      :row-class-name="tableClassName"
      :default-expand-all="true"
      border
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="chapterName" label="章名称" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.isChapter ? scope.row.chapterName : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="sectionName" label="节名称" min-width="110"> </el-table-column>
      <el-table-column prop="materialCategory" label="文件类型" width="80">
        <template slot-scope="scope">
          {{ ['未分类', '视频', '音频', '文档', '直播'][scope.row.materialCategory] }}
        </template>
      </el-table-column>
      <el-table-column prop="videoName" label="文件名称" min-width="140"> </el-table-column>
      <el-table-column prop="coverImageUrl" label="封面图片" min-width="140">
        <template v-if="scope.row.coverImageUrl" slot-scope="scope">
          <div class="imageBorder">
            <img :src="scope.row.coverImageUrl" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="teacherName" label="主讲讲师" min-width="140"> </el-table-column>
      <el-table-column prop="duration" label="资源时长" min-width="140"> </el-table-column>
      <el-table-column prop="videoPlatform" label="视频平台" min-width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.videoPlatform == 0">阿里云</span>
          <span v-else-if="scope.row.videoPlatform == 1">保利威</span>
          <span v-else-if="scope.row.videoPlatform == 2">华为云</span>
          <span v-else-if="scope.row.videoPlatform == 4">课通云</span>
          <span v-else-if="scope.row.videoPlatform == 5">腾讯</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.isChapter"
            type="text"
            size="small"
            @click="handleSectionAdd(scope.row)"
          >
            新增节
          </el-button>
          <el-button
            v-if="!scope.row.isChapter"
            type="text"
            size="small"
            @click.native.prevent="handleReview(scope.row)"
          >
            预览
          </el-button>
          <el-button type="text" size="small" @click.native.prevent="handleEdit(scope.row)">
            编辑
          </el-button>
          <el-button type="text" size="small" @click.native.prevent="handleDelete(scope.row)">
            删除
          </el-button>
          <SectionAdd
            v-if="!scope.row.isChapter"
            :ref="`SectionAdd-${scope.row.rowKey}`"
            :key="scope.row.rowKey"
            :section="scope.row"
            @success="getCourseSection"
            @close="onClose(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      class="addSectionDialog"
      :title="title"
      :visible.sync="chapterDialogVisible"
      :before-close="closeChapterClear"
      :close-on-click-modal="false"
      width="30%"
      top="20vh"
    >
      <el-input v-model="chapterTitle"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeChapterClear">取 消</el-button>
        <el-button type="primary" @click="handleChapterSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="videoReviewDialog"
      width="800px"
      :visible.sync="videoReviewVisible"
      title="预览"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div id="prism-player" class="prism-player"></div>
    </el-dialog>
  </div>
</template>
<script>
import Sortable from 'sortablejs'
let sortTable
import { getuid } from '@/utils'
// import { Base64 } from 'js-base64'
import {
  CourseChapterCreate,
  CourseChapterList,
  courseChapteSort,
  courseSectionSort,
  chapterUpdate,
  chapterDelete,
  sectionDelete,
  videoDetail,
} from '@/api/course'
import to from 'await-to'
import SectionAdd from './components/SectionAddModal'
export default {
  components: {
    SectionAdd,
  },
  data() {
    return {
      loading: false,
      sectionList: [],
      chapterDialogVisible: false,
      chapterTitle: '',
      editChapterId: '',
      courseId: this.$route.params.courseId,
      tileSectionList: {},
      videoReviewVisible: false,
      currentVideoSrc: '',
      docReviewVisible: false,
      IsCreate: true,
      htmlReviewVisible: false,
      currentHtmlContent: '',
      title: '新增章',
      player: null,
    }
  },
  mounted() {
    if (this.courseId) {
      this.getCourseSection()
    }
  },
  methods: {
    // 将树数据转化为平铺数据
    treeToTile(treeData, childKey = 'children') {
      const arr = []
      const expanded = data => {
        if (data && data.length > 0) {
          data
            .filter(d => d)
            .forEach(e => {
              arr.push(e)
              expanded(e[childKey] || [])
            })
        }
      }
      expanded(treeData)
      return arr
    },
    rowDrop() {
      const tbody = this.$refs.sectionTable.$el.querySelectorAll(
        '.el-table__body-wrapper > table > tbody',
      )[0]
      sortTable = Sortable.create(tbody, {
        animation: 300,
        fallbackOnBody: true,
        dataIdAttr: 'class',
        onStart: ({ oldIndex }) => {
          this.tileSectionList = this.treeToTile(this.sectionList)
          const oldRow = this.tileSectionList[oldIndex]
          if (oldRow.isChapter && oldRow.children.length) {
            this.$refs.sectionTable.toggleRowExpansion(oldRow, false)
          }
        },
        onMove: ({ dragged, related }) => {
          const oldRow = this.tileSectionList[dragged.rowIndex]
          if (dragged.rowIndex !== related.rowIndex) {
            const newRow = this.tileSectionList[related.rowIndex]
            console.log(oldRow.chapterId !== newRow.chapterId && !oldRow.isChapter)
            if (oldRow.chapterId !== newRow.chapterId && !oldRow.isChapter) {
              return false
            }
            console.log(oldRow.isChapter !== newRow.isChapter)
            if (oldRow.isChapter !== newRow.isChapter) {
              return false
            }
          }
        },
        onEnd: ({ oldIndex, newIndex }) => {
          const oldRow = this.tileSectionList[oldIndex]
          const newRow = this.tileSectionList[newIndex]
          let arr = sortTable.toArray()
          for (let index = 0; index < arr.length; index++) {
            arr[index] = arr[index].match(/id=([\d,\w]{32})/)[1]
          }
          let allChapter = this.tileSectionList.filter(item => item.isChapter)
          if (oldRow.isChapter == newRow.isChapter && oldRow.isChapter === true) {
            let sortAllChapter = arr
              .map(item => allChapter.find(i => i.rowKey == item)?.chapterId)
              .filter(item => item)
            console.log(sortAllChapter, '排序后的章')
            this.sortChapter(sortAllChapter)
          }
          if (oldRow.isChapter == newRow.isChapter && oldRow.isChapter === false) {
            let currentChapter = allChapter.filter(item => item.chapterId === oldRow.chapterId)[0]
            let sortAllSection = arr
              .map(item => currentChapter.children.find(i => i.rowKey == item)?.sectionId)
              .filter(item => item)
            console.log(sortAllSection, currentChapter, '排序后的节')
            this.sortSection(sortAllSection, currentChapter.chapterId)
          }
        },
      })
    },
    async sortChapter(sortedIdList) {
      this.loading = true
      const [, err] = await to(
        courseChapteSort({ chapterIds: sortedIdList, courseId: this.courseId }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      // this.$message.success('排序成功')
      this.getCourseSection()
    },
    async sortSection(sortedIdList, chapterId) {
      this.loading = true
      const [, err] = await to(
        courseSectionSort({ sectionIds: sortedIdList, chapterId: chapterId }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
    },
    async getCourseSection() {
      this.loading = true
      const [res, err] = await to(CourseChapterList({ courseId: this.courseId }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.sectionList = res.data.chapters
      this.rowDrop()
    },
    handleChapterSubmit() {
      if (!this.IsCreate) {
        this.handleUpdateCourseChapter()
      } else {
        this.handleAddCourseChapter()
      }
    },
    async handleAddCourseChapter() {
      if (!this.chapterTitle) return this.$message.error('请输入章节名称')
      const [, err] = await to(
        CourseChapterCreate({
          courseId: this.courseId,
          chapterName: this.chapterTitle,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.$message.success('新增成功')
      this.chapterDialogVisible = false
      this.chapterTitle = ''
      this.getCourseSection()
    },
    async handleUpdateCourseChapter() {
      if (!this.chapterTitle) return this.$message.error('请输入章节名称')
      const [, err] = await to(
        chapterUpdate({
          courseId: this.courseId,
          id: this.editChapterId,
          chapterName: this.chapterTitle,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.$message.success('编辑成功')
      this.chapterDialogVisible = false
      this.chapterTitle = ''
      this.editChapterId = ''
      this.getCourseSection()
    },
    handleDelete(row) {
      if (row.isChapter) {
        this.deleteChapter(row)
      } else {
        this.deleteSection(row)
      }
    },
    async deleteChapter(row) {
      this.$confirm('您确定要删除所选章吗?删除后将无法恢复', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(chapterDelete({ id: row.chapterId, courseId: this.courseId }))
          if (err) return this.$message.warning(err.msg)
          this.$message({ message: '删除成功', type: 'success' })
          this.getCourseSection()
        })
        .catch(() => {})
    },
    async deleteSection(row) {
      this.$confirm('您确定要删除所选节吗?删除后将无法恢复', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(sectionDelete({ id: row.sectionId, courseId: this.courseId }))
          if (err) return this.$message.warning(err.msg)
          this.$message({ message: '删除成功', type: 'success' })
          this.getCourseSection()
        })
        .catch(() => {})
    },
    handleChapterAdd() {
      this.chapterDialogVisible = true
      this.IsCreate = true
      this.chapterTitle = ''
      this.editChapterId = ''
    },
    closeChapterClear() {
      this.chapterDialogVisible = false
      this.chapterTitle = ''
      this.IsCreate = true
      this.editChapterId = ''
      this.title = '新增章'
    },
    handleEdit(row) {
      if (row.isChapter) {
        this.IsCreate = false
        this.title = '编辑章'
        this.editChapterId = row.chapterId
        this.chapterDialogVisible = true
        if (row.chapterName) {
          this.chapterTitle = row.chapterName
        }
      } else {
        this.$refs[`SectionAdd-${row.rowKey}`].show()
      }
    },
    handleSectionAdd(row) {
      const rowKey = getuid()
      let lastFileIndex
      row.children.map((item, index) => {
        if (!item.isChapter) {
          lastFileIndex = index
        }
      })
      row.children.splice(lastFileIndex + 1, 0, {
        rowKey,
        chapterId: row.chapterId,
        isChapter: false,
        children: [],
        chapterName: row.chapterName,
        isCreate: true,
      })
      this.$nextTick(() => {
        this.$refs[`SectionAdd-${rowKey}`].show()
        this.$refs.sectionTable.toggleRowExpansion(row, true)
      })
    },
    onClose(row) {
      this.sectionList.map(item => {
        if (item.chapterId == row.chapterId) {
          item.children.map((e, i) => {
            if (e.isCreate && e.rowKey == row.rowKey) item.children.splice(i, 1)
          })
        }
      })
    },
    tableClassName({ row }) {
      return 'id=' + row.rowKey
    },
    async getPlayUrl(videoId, videoPlatform) {
      const [res, err] = await to(videoDetail({ videoId: videoId, videoPlatform: videoPlatform }))
      if (err) {
        this.$message.warning(err.msg)
        return false
      }
      return res.data
    },
    async handleReview(row) {
      this.videoReviewVisible = true
      const currentVideoSrc = await this.getPlayUrl(row.videoId, row.videoPlatform)
      this.currentVideoSrc = currentVideoSrc.videoUrl

      // eslint-disable-next-line no-undef
      this.player = new Aliplayer({
        id: 'prism-player',
        source: this.currentVideoSrc,
        width: '100%',
        height: '500px',
        autoplay: true,
        isLive: false,
        rePlay: true,
        controlBarVisibility: 'hover',
      })
    },
    handleClose() {
      this.videoReviewVisible = false
      this.player.dispose()
      this.currentVideoSrc = ''
    },
  },
}
</script>
<style scoped lang="scss">
.chapterInfo {
  background: #ffffff;
  height: calc(100% - 30px);
  overflow-y: auto;
  padding-top: 30px;
  padding-left: 10px;
  padding-right: 10px;
  .header {
    margin-bottom: 20px;
  }
  .imageBorder {
    width: 80px;
    height: 50px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .addSectionDialog {
    ::v-deep .el-dialog__footer {
      border-top: none;
      .el-button {
        width: 120px;
      }
    }
  }
  .videoReviewDialog {
    video {
      width: 100%;
      height: 440px;
    }
  }
  ::v-deep .docReviewDialog {
    height: 100vh;
    .el-dialog {
      height: 92vh;
    }
    .el-dialog__body {
      padding: 0;
      height: calc(100% - 55px);
    }
  }
  ::v-deep .htmlReviewDialog {
    .el-dialog__body {
      max-height: calc(100% - 55px);
    }
  }
}
</style>
